import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  display: none;
  ${({ theme }) => theme.media.wideScreenUp`
    display: block;
    flex: 1;
  `};
`;

const Container = ({ children, className }) => {
  return <StyledDiv className={className}>{children}</StyledDiv>;
};

export default Container;
